module.exports = __webpack_public_path__ + "img/read.6912f60b.png";